import { useMutation, useQueryClient } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { toast } from 'react-toastify';

export const useUpdateSingleAppointmentType = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data) => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      return handleRequest(
        'put',
        `facility/${user.facility}/appointment-types/${data._id}`,
        true,
        data,
      );
    },
    {
      onSuccess: async () => {
        toast('Appointment type was successfully updated', {
          type: 'success',
          style: { width: 'auto' },
        });
        queryClient.invalidateQueries([cacheKeys.getAppointmentTypes()]);
      },
      onError: async (err) => {
        toast('Unable to update appointment type', {
          type: 'error',
          style: { width: 'auto' },
        });
        console.error(
          `Failed to update appointment type: ${
            err.response?.data.message || err.message
          }`,
        );
      },
    },
  );

  return mutation;
};
